import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';

class MakeTodoWriteByCopy {
  static todo_write_default = {
    "a_ymd": "",
    "a_seq": "",
    "a_is_mcomp_public": "",
    "a_sort": "homework",
    "a_sort_det":"",
    "a_par_id": "",
    "a_par_seq": "",
    "a_is_reserve": "",
    "a_reserve_start_date": "",
    "a_reserve_end_date": "",
    "a_success_sort": "",
    "a_amount_sort": "",
    "a_success_amount": "",
    "a_success_amount_start": "",
    "a_success_time_sec": "",
    "a_subject": "",
    "a_title": "",
    "a_content": "",
    "a_is_need_photo": "",
    "a_add_file_type":"image",
    "cg_word_arr":[],
  }
  static action(inData: any) {
    let opt_obj = {
      todo_content_arr: [],
      make_option: {
        "is_mcomp_publiic": "1",
        "is_reserve": "1",//예정여부
        "reserve_start_date": "",
        "reserve_end_date": "",
        "one_day_amount": 1,
        "one_day_amount_time": 1,
        "one_day_amount_over_per": 100,
        "apply_day": "1,2,3,4,5",
        "distribute_standard": "",
        "is_need_photo": "",

        "start_h": "00",
        "start_m": "00",
        "end_h": "01",
        "end_m": "00",
      },
      ...inData
    };
    let this_obj = this;
    let todo_content_arr = opt_obj["todo_content_arr"];
    let make_option = opt_obj["make_option"];
    let apply_day_arr = make_option["apply_day"].split(",");
    let todo_write_arr: any = [];

    let start_date = make_option["reserve_start_date"];
    let end_date = make_option["reserve_end_date"];
    let ing_date = start_date;//진행중인날짜
    if (end_date < start_date) {
      return todo_write_arr;
    }
    let diff_day_num = DateFunc.get_diff_days_of_date(new Date(start_date), new Date(end_date));
    diff_day_num = diff_day_num + 1;

    for (let ing_i = 0; ing_i < diff_day_num; ing_i++) {
      let ing_date_json = DateFunc.get_date_json(new Date(ing_date));
      if (strFunc.str_in_array(ing_date_json.day, apply_day_arr) == -1) {
        ing_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(ing_date), 'day', +1), "Y-m-d");
        continue;
      }

      for (let i = 0; i < todo_content_arr.length; i++) {
        let todo_content = todo_content_arr[i];
        let add_todo_write_row = {
          ...this_obj.todo_write_default,
          "a_ymd": strFunc.str_replace("-", "", ing_date),
          "a_is_mcomp_public": make_option["is_mcomp_publiic"],
          "a_sort": todo_content["a_sort"],
          "a_sort_det": todo_content["a_sort_det"],
          "a_par_id": todo_content["a_par_id"],
          "a_par_seq": todo_content["a_par_seq"],
          "a_is_reserve": make_option["is_reserve"],
          "a_reserve_start_date": ing_date,
          "a_reserve_end_date": ing_date,
          "a_success_sort": todo_content["a_success_sort"],
          "a_amount_sort": todo_content["a_amount_sort"],
          "a_success_amount": todo_content.row_view_success_amount,
          "a_success_time_sec": todo_content.a_success_time_sec,
          "a_subject": todo_content["a_subject"],
          "a_title": todo_content["a_title"],
          "a_content": todo_content["a_content"],
          "a_is_need_photo": make_option["is_need_photo"],
          "a_add_file_type": todo_content["a_add_file_type"],
          "cg_word_arr":todo_content["cg_word_arr"],
        };
        todo_write_arr.push(add_todo_write_row);
      }
      ing_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(ing_date), 'day', +1), "Y-m-d");
    }

    return todo_write_arr;
  }
}
export default MakeTodoWriteByCopy;